<!-- 可跟踪详情 -->
<template>
  <div class="h-100 uk-padding-small border-box">
    <div class="uk-margin-small-bottom">
      <el-radio-group v-model="traceMode">
        <el-radio-button
          label="realtime"
          :disabled="tracableInfo.transit !== 1"
        >
          {{ $t('integration.real_time_trajectory') }}
        </el-radio-button>
        <el-radio-button label="history"
          >{{ $t('integration.historical_track') }}
        </el-radio-button>
      </el-radio-group>
    </div>
    <div style="height:calc(100% - 42px)">
      <div style="height:calc(100% - 300px)">
        <component
          :is="traceMode"
          :tracableInfo="tracableInfo"
          :mapcom="mapcom"
          :tab="traceMode"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
import RealtimeTrace from '@/pages/dataBoard/mapMonitor/components/ArchDetail/trace/RealtimeTrace'
import HistoryTrace from '@/pages/dataBoard/mapMonitor/components/ArchDetail/trace/HistoryTrace'
import TraceMap from '@/pages/dataBoard/mapMonitor/components/ArchDetail/TraceMap'

export default {
  props: ['tracableInfo'],
  components: {
    TraceMap,
    realtime: RealtimeTrace,
    history: HistoryTrace
  },
  watch: {
    tracableInfo: {
      immediate: true,
      handler () {
        if (!this.tracableInfo.transit) {
          this.traceMode = 'history'
        }
      }
    }
  },
  data () {
    return {
      traceMode: 'realtime',
      // map组件实例 需要传递到子组件调用
      mapcom: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.mapcom = this.$refs.mapcom
    })
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
  width: 100%;

  .el-radio-button {
    width: 50%;

    .el-radio-button__inner {
      width: 100%;
      height: 32px;
      line-height: 15px;
    }
  }
}
</style>
